import React from 'react';
import './Loader.css';
import loader from '../../assets/images/ailoader.gif';

interface PropData {
  show: boolean;
}

const Loader = (props: PropData) => {
  return (
    <>
      {props.show && (
        <div className="resultLoading">
          <div className="bg"></div>
          <div className="loader-container">
            <img src={loader} alt="Loader" className="loader-img" />
            <div className="loading-text">Loading...</div>
          </div>
        </div>
      )}
    </>
  );
};

export default Loader;
